import {
  GET_COLLECTION_ITEM,
  GET_COLLECTION_ITEM_SUCCESS,
  GET_COLLECTION_ITEM_ERROR,
  UPDATE_COLLECTION_ITEM,
  UPDATE_COLLECTION_ITEM_SUCCESS,
  UPDATE_COLLECTION_ITEM_ERROR,
  CLEAR_COLLECTION_ITEM
} from "../actions";

const INIT_STATE = {
  collectionItemId: null,
  collectionItem: null,
  collectionItemDetailsError: "",
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_COLLECTION_ITEM:
      return {
        ...state,
        loading: true,
        collectionItemId: action.payload.collectionItemId,
        collectionItemDetailsError: "",
      };
    case GET_COLLECTION_ITEM_SUCCESS:
      return {
        ...state,
        loading: false,
        collectionItemDetailsError: "",
        collectionItem: action.payload.collectionItem
      };
    case GET_COLLECTION_ITEM_ERROR:
      return { ...state, loading: false, collectionItemDetailsError: action.payload ? action.payload.message : "" };
    case UPDATE_COLLECTION_ITEM:
      return {
        ...state,
        loading: true,
        collectionItem: action.payload.collectionItem,
        collectionItemDetailsError: "",
      };
    case UPDATE_COLLECTION_ITEM_SUCCESS:
      return {
        ...state,
        loading: false,
        collectionItemDetailsError: "",
        collectionItem: action.payload.collectionItem
      };
    case UPDATE_COLLECTION_ITEM_ERROR:
      return { ...state, loading: false, collectionItemDetailsError: action.payload ? action.payload.message : "" };
    case CLEAR_COLLECTION_ITEM:
      return INIT_STATE;     
    default:
      return { ...state };
  }
};
